import { Box } from "@mittwald/flow-components/dist/components/Box";
import { H3 } from "@mittwald/flow-components/dist/components/H3";
import HorizontalRuler from "@mittwald/flow-components/dist/components/HorizontalRuler";
import PriceBox from "@mittwald/flow-components/dist/components/PriceBox";
import { PriceTable } from "@mittwald/flow-components/dist/components/PriceTable";
import TranslationProvider from "@mittwald/flow-components/dist/components/TranslationProvider/TranslationProvider";
import { useTranslation } from "@mittwald/flow-components/dist/hooks/useTranslation";
import { extractTextFromReactNode } from "@mittwald/flow-components/dist/lib/extractTextFromReactNode";
import { joinTranslationKeys } from "@mittwald/flow-components/dist/lib/translation";
import React from "react";
import type {
  RelocationFormData,
  RelocationReferrer,
} from "../../RelocationRequestWidget";
import {
  additionalDataComparePrice as additionalDataComparePriceFromArticle,
  domainTransferPricePerDomain,
  getArticleByName,
} from "../../utils/articles";

interface OverviewBoxProps {
  referrer: RelocationReferrer;
  form: RelocationFormData;
}

export const OverviewBox: React.FC<OverviewBoxProps> = (props) => {
  const { referrer, form } = props;
  const translate = useTranslation();

  const article = form.articleType;
  const translatedArticleName = extractTextFromReactNode(
    translate(
      joinTranslationKeys(
        "component",
        "orderOverview",
        "relocation",
        "type",
        article,
      ),
    ),
  );
  const additionalServices = form.additionalServices;
  const domains = form.domains;

  const additionalDataComparePrice =
    additionalServices.dataCompare === "additionalCompare"
      ? additionalDataComparePriceFromArticle
      : 0;
  const domainTransferPrice =
    domains !== undefined && domains.length > 0
      ? domains.length * domainTransferPricePerDomain
      : 0;

  const currentTotal =
    getArticleByName(article).price +
    additionalDataComparePrice +
    domainTransferPrice;

  return (
    <TranslationProvider name="orderOverview" type="component">
      <Box _itemGap="s">
        <H3 i18n="title" />
        <H3 _color="default" i18n="relocationService" />
        <PriceTable twoColumns>
          <PriceTable.Row
            monthlyPrice={getArticleByName(article).price}
            strong={false}
            title={{
              id: "relocationType",
              values: {
                articleName: translatedArticleName,
              },
            }}
          />
          {additionalServices.dataCompare === "additionalCompare" && (
            <PriceTable.Row
              monthlyPrice={additionalDataComparePriceFromArticle}
              strong={false}
              title="additionalDataCompare"
            />
          )}
          {domainTransferPrice > 0 && (
            <PriceTable.Row
              monthlyPrice={domainTransferPrice}
              strong={false}
              title={{
                id: "domainTransfer",
                values: {
                  domainCount: (domains || []).length,
                },
              }}
            />
          )}
          {referrer === "widget" ? (
            <>
              <HorizontalRuler _my="s" />
              <PriceTable.Row
                monthlyPrice={currentTotal}
                monthlyPriceSubline="plusTaxes"
                strong
                title="total"
              />
            </>
          ) : (
            <PriceBox singlePrice={currentTotal} title="total" />
          )}
        </PriceTable>
      </Box>
    </TranslationProvider>
  );
};
